import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { useTemplateColors } from 'PDF/TemplateEngine/TemplateColorsContext';
import { replaceVariables } from 'PDF/TemplateEngine/utils/replaceVariables';

// Body type 'meta-grid': 2 cajas lado a lado, cada una con header + filas
// dt/dd (key/value). dd soporta {var} embebidas. config: { boxes: [...] }.
function MetaGridSection({ section, data }) {
  const { colors, FONT } = useTemplateColors();
  const boxes = Array.isArray(section?.config?.boxes) ? section.config.boxes : [];
  const styles = StyleSheet.create({
    grid: { flexDirection: 'row', gap: '0.25cm' },
    box: { flex: 1, border: `1px solid ${colors.border}`, borderRadius: 8 },
    bh: {
      backgroundColor: colors.lightBg,
      borderBottom: `1px solid ${colors.border}`,
      paddingVertical: '0.18cm',
      paddingHorizontal: '0.28cm',
    },
    bhText: {
      fontSize: 8,
      fontFamily: FONT.bold,
      color: colors.muted,
      textTransform: 'uppercase',
      letterSpacing: 0.5,
    },
    rows: { paddingVertical: '0.18cm', paddingHorizontal: '0.28cm', gap: '0.12cm' },
    row: { flexDirection: 'row', justifyContent: 'space-between', gap: '0.3cm', alignItems: 'flex-start' },
    dt: { fontSize: 9, fontFamily: FONT.base, color: colors.textFade || colors.muted, flexShrink: 0 },
    dd: {
      flex: 1,
      flexShrink: 1,
      fontSize: 9,
      fontFamily: FONT.base,
      color: colors.text || colors.darkText,
      textAlign: 'right',
    },
    ddMono: { fontFamily: 'Courier' },
  });
  return (
    <View style={styles.grid}>
      {boxes.map((box, bi) => (
        <View key={bi} style={styles.box}>
          <View style={styles.bh}>
            <Text style={styles.bhText}>{box.title}</Text>
          </View>
          <View style={styles.rows}>
            {(box.rows || []).map((r, ri) => (
              <View key={ri} style={styles.row}>
                <Text style={styles.dt}>{r.dt}</Text>
                <Text style={r.mono ? { ...styles.dd, ...styles.ddMono } : styles.dd}>
                  {replaceVariables(r.dd, data || {})}
                </Text>
              </View>
            ))}
          </View>
        </View>
      ))}
    </View>
  );
}

export default MetaGridSection;
